import React from 'react';
import './BrokerAPIRequirements.css';

const BrokerAPIRequirements = () => {
  return (
    <div className="broker-api-container">
      <header className="broker-api-header">
        <div className="broker-api-logo">ANBPay</div>
        <h1>Broker API Requirements</h1>
      </header>

      {/* Required Data */}
      <div className="broker-api-card">
        <h2><span className="num">1</span> Required User Data</h2>
        <p className="card-description">Please provide the following data for each user via API:</p>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>Field</th>
                <th>Type</th>
                <th>Example</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span className="field">id</span></td>
                <td><span className="type">string</span></td>
                <td>Unique user ID from your system<br/><span className="example">BU001</span></td>
              </tr>
              <tr>
                <td><span className="field">name</span></td>
                <td><span className="type">string</span></td>
                <td>Full name as on CNIC<br/><span className="example">Muhammad Ahmed Khan</span></td>
              </tr>
              <tr>
                <td><span className="field">cnic</span></td>
                <td><span className="type">string</span></td>
                <td>CNIC number with dashes<br/><span className="example">35201-1234567-1</span></td>
              </tr>
              <tr>
                <td><span className="field">cnicExpiry</span></td>
                <td><span className="type">string</span></td>
                <td>Expiry date (DD-MM-YYYY)<br/><span className="example">15-03-2028</span></td>
              </tr>
              <tr>
                <td><span className="field">cnicFrontImage</span></td>
                <td><span className="type">base64</span></td>
                <td>CNIC front image<br/><span className="example">data:image/jpeg;base64,/9j/4AA...</span></td>
              </tr>
              <tr>
                <td><span className="field">cnicBackImage</span></td>
                <td><span className="type">base64</span></td>
                <td>CNIC back image<br/><span className="example">data:image/jpeg;base64,/9j/4AA...</span></td>
              </tr>
              <tr>
                <td><span className="field">email</span></td>
                <td><span className="type">string</span></td>
                <td>User email<br/><span className="example">user@example.com</span></td>
              </tr>
              <tr>
                <td><span className="field">phone</span></td>
                <td><span className="type">string</span></td>
                <td>Phone with country code<br/><span className="example">+923001234567</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="note">
          <strong>Image Requirements:</strong> JPG/PNG, max 5MB, min 600x400px, clear and readable
        </div>
      </div>

      {/* Example Response */}
      <div className="broker-api-card">
        <h2><span className="num">2</span> Expected Response Format</h2>
        <div className="code-block">
          <pre>{`{
  "success": true,
  "data": {
    "id": "BU001",
    "name": "Muhammad Ahmed Khan",
    "cnic": "35201-1234567-1",
    "cnicExpiry": "15-03-2028",
    "cnicFrontImage": "data:image/jpeg;base64,/9j/4AAQ...",
    "cnicBackImage": "data:image/jpeg;base64,/9j/4AAQ...",
    "email": "ahmed.khan@example.com",
    "phone": "+923001234567"
  }
}`}</pre>
        </div>
      </div>

      {/* Contact */}
      <div className="broker-api-contact">
        <p>Questions? Contact us</p>
        <a href="mailto:info@anbvision.com">info@anbvision.com</a>
      </div>

      <footer className="broker-api-footer">
        ANBPay | Version 1.0 | 2026
      </footer>
    </div>
  );
};

export default BrokerAPIRequirements;
